<template>
    <div>
        <b-card>
        <b-row>
        <b-col xl="1">
            <b-form-select v-model="selected" :options="options"></b-form-select>
        </b-col>
        <b-col xl="1">
            <select :disabled="tdocdisabled" class="custom-select mr-sm-2 input-placedark input-dark" id="inlineFormCustomSelect" v-model="tipoDocumento">                       
                <option :value="tipodocumento.tipo" v-for="tipodocumento in documentosIdentidad" v-bind:key="tipodocumento.tipo">
                    {{ tipodocumento.nombre }}
                </option>
            </select> 
        </b-col>
        <b-col xl="2" >
            <b-input-group>
                <b-form-input type="text" :disabled="tipoDocumento==0" class="form-control address" v-model="receptor.numero" placeholder="Documento" autofocus @change="getReceivers()"></b-form-input>
                    <b-input-group-text slot="append">
                        <b-button size="sm" @click="closeList()" variant="success" class="sinresultados"><i class="fas fa-arrow-up"></i></b-button>
                    </b-input-group-text>
            </b-input-group>
            <template v-if="cargandoreceptor">
                <b-list-group class="searcher-field">
                    <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item>
                </b-list-group>
            </template>
            <b-list-group v-if="listarec" class="searcher-field">
                <template v-for="(item, index) in listaReceptores" class="buscarRuc">
                    <b-list-group-item :key="index" @click="setReceiver(item)" class="searcher-result">
                        {{item.idReceptor + ' - ' + item.razonSocial}}
                    </b-list-group-item>
                </template>
            </b-list-group>
            <b-list-group v-if="mostrardni" class="searcher-field">
                <b-list-group-item v-if="norecdni">No hay Receptores con ese número</b-list-group-item>                                 
                    <template >
                        <b-list-group-item  @click="setReceiverdni(listadni)" class="searcher-result">{{listadni.nombre + ' -- ' + listadni.dni}}</b-list-group-item>
                    </template> 
            </b-list-group>
        </b-col>
        <b-col xl="2">
            <div class="form-label-group">
                <b-form-input type="text" class="form-control address" @input="pitcherReceiver()" v-model="receptor.razonSocial" placeholder="Atencion a" autofocus></b-form-input>
                <label>Razon Social</label>
            </div>
        </b-col>
        <b-col xl="4">
            <div class="form-label-group">
                <b-form-input type="text" class="form-control address" v-model="receptor.direccion" placeholder="Dirección" autofocus></b-form-input>
                <label>Dirección</label>
             </div>
        </b-col>
        <b-col xl="1">
            <select class="custom-select mr-sm-2 input-placedark input-dark" v-model="moneda">
                <option :value="moneda" v-for="moneda in tipoMoneda" v-bind:key="moneda.id">
                {{ moneda.descripcion }}
                </option>
            </select>
        </b-col>
        <b-col xl="1">
            <b-input-group>
                <template v-if="seriesCargadas">
                    <b-button size="md" variant="secondary" outline-success>
                        Cargando Series... <i class="fa fa-spin fa-spinner"></i>
                    </b-button>
                </template>
                <template v-else>
                    <select class="form-control input-placedark input-dark" v-model="indexSerie">
                        <option v-for="(serie, index) in listaSeries" :value="index" :key="index">{{ serie }}</option>
                    </select>
                </template>
            </b-input-group>
        </b-col>
        </b-row>
        <!-- buscador fin cabecera -->
        <br>
        <div class="caja1">
        <!-- TABLA -->
       <b-row>
           <b-col cols="12">
                <b-table 
                :items="items" 
                :fields="items_fields"
                outlined
                bordered
                responsive
                >
                <template slot="cantidad" slot-scope="row">
                    <b-form-input  @keyup.enter="agregarCambioMoneda(row.item,row.index)" v-model="row.item.cantidad"></b-form-input>
                </template>
                <template  slot="precioVentaUnitario" slot-scope="row">
                    <b-input  v-model="row.item.precioUnitario"></b-input>
                </template>
                <template slot="accion" slot-scope="row">
                        <b-button-group>
                        <b-button title="Agregar" size="sm" :disabled="validaMoneda(row.item.cantidad)" @click="agregarCambioMoneda(row.item,row.index)" variant="success"><i class="fas fa-shopping-basket"></i></b-button>
                        <!-- <b-button title="Borrar" size="sm"  variant="danger" @click="borrarItems(row.index)"><i class="fas fa-trash"></i></b-button> -->
                        </b-button-group>
                </template>
                </b-table>
           </b-col>
       </b-row>
       </div>
       <!-- vista previa -->
       <div class="caja2">
        <b-row>
            <b-col>
                <b-table 
                :items="itemsAgregados" 
                :fields="items_Agregados"
                outlined
                bordered               
                responsive>
                <template slot="total" slot-scope="row">
                 {{(row.item.precioVentaUnitario * row.item.cantidad).toFixed(2)}}
                </template>
                <template slot="borrar" slot-scope="row">
                    <b-button size="sm" @click="borrarCambio(row.index)" title="borrar" variant="danger"><i class="fas fa-trash"></i></b-button>
                </template>
                </b-table>
            </b-col>
        </b-row>
        <br><br>
        <hr>
        <div style="border: 2px solid #ccc;border-radius: 10px;width:48%;float:left">
            <div class="mt-2 mb-2 pl-2 pr-2">
                <div class="text-center mb-4"><b>CONCEPTO TOTALES</b></div> 
                <b-row>
                    <b-col cols="6" sm="6"	md="6"	lg="6"	xl="5">
                      <b>Total Venta:</b>
                    </b-col>
                    <b-col cols="2" sm="2"	md="2"	lg="2"	xl="3">
                        {{moneda.simbolo}}
                    </b-col>
                    <b-col cols="4" sm="4"	md="4"	lg="4"	xl="4">
                        {{sumarTotales()}}
                    </b-col>
                </b-row>
            </div>
        </div>
        <div style="border:2px solid #ccc;border-radius:10px;width:50%;float:right">
            <div class="mt-2 mb-2 pl-2 pr-2">
                <div class="text-center"><b>PAGAR</b></div>
                <br>
                <b-row>
                    <b-col cols="1"></b-col>
                    <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="3"><img title="Pago con Yape" class="formasPagosImg" src="images/yape.png" @click="pagosImg(1)"><h5 v-if="colorPago1"><b-badge style="color:green">Yape</b-badge></h5><p v-else>Yape</p></b-col>
                    <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="3"><img title="Pago con Plin" class="formasPagosImg" src="images/plin.png" @click="pagosImg(2)"><h5 v-if="colorPago2"><b-badge style="color:green">Plin</b-badge></h5><p v-else>Plin</p></b-col>
                    <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="3"><img title="T.Débito" class="formasPagosImg" src="images/tDebito.png" @click="pagosImg(4)"><h5 v-if="colorPago4"><b-badge style="color:green">T.Débito</b-badge></h5><p v-else>T.Débito</p></b-col>
                </b-row>
                <b-row>
                    <b-col cols="1"></b-col>
                    <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="3"><img title="Pago Efectivo" class="formasPagosImg" src="images/efectivo1.png" @click="pagosImg(5)"><h5 v-if="colorPago5"><b-badge style="color:green">Efectivo</b-badge></h5><p v-else>Efectivo</p></b-col>
                    <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="3"><img title="T.Crédito" class="formasPagosImg" src="images/tCredito.png" @click="pagosImg(6)"><h5 v-if="colorPago6"><b-badge style="color:green">T.Crédito</b-badge></h5><p v-else>T.Crédito</p></b-col>
                    <!-- <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="3"><img title="Transferencia Bancos" class="formasPagosImg" src="images/transBancos.png" @click="pagosImg(8)"><h5 v-if="colorPago8"><b-badge style="color:green">Trans.Fondos</b-badge></h5><p v-else>Trans. Fondos</p></b-col> -->
                    <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="3"><img title="Depósito en Cuenta" class="formasPagosImg" src="images/depositoCuenta.png" @click="pagosImg(7)"><h5 v-if="colorPago7"><b-badge style="color:green">Déposito Cuenta</b-badge></h5><p v-else>Déposito Cuenta</p></b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col xl="12">
                        <b-input-group>
                            <select class="custom-select mr-sm-2 input-placedark input-dark" v-model="formadepago">
                                <option :value="fpago" v-for="fpago in formaPago" v-bind:key="fpago.codigo">
                                    {{ fpago.nombre }}
                                </option>
                            </select>
                        </b-input-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col xl="12">
                        <b-form-input placeholder="0.00" v-model="fpago" @keyup.enter="pagos()"></b-form-input>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                   <b-col xl="12">
                        <b-list-group>
                         <b-list-group-item v-for="(item, index ) in listaPagos" :key="index">
                            <b-row>
                                <b-col xl="5">
                                    {{ item.descripcion.substring(0,10) }}...
                                </b-col>
                                <b-col xl="2">
                                    {{ moneda.simbolo }}
                                </b-col>
                                <b-col xl="3">
                                    {{item.monto}}
                                </b-col>
                                <b-col xl="1">
                                    <i @click="removePago(index)" class="fa fa-times-circle text-danger" style="cursor:pointer"></i>
                                </b-col>      
                            </b-row> 
                            </b-list-group-item>
                         </b-list-group>
                   </b-col>
                </b-row>
                <hr>
                <b-row>
                    <b-col>
                        <div class="pl-4">
                            <b>pago</b>
                        </div>
                    </b-col>
                     <b-col>
                        <div class="pl-4">
                            {{moneda.simbolo}} {{pagoFinal()}}
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div class="pl-4">
                            <b>vuelto</b>
                        </div>
                    </b-col>
                     <b-col>
                        <div class="pl-4">
                            {{moneda.simbolo}} {{(vuelto).toFixed(2)}}
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>
       </div> <!-- TERMINA CAJA 2 -->
       <div style="margin-top:1%;float:right;margin-right:9%">
            <b-row>
                <b-col>
                    <b-button v-if="!cargando" title="Emitir Documento" :disabled="validarDatos()" @click="validarImporte()" variant="primary">Emitir <i class="far fa-paper-plane"></i></b-button>
                    <b-button v-else variant="primary" disabled>Emitiendo... <i class="fas fa-spin fa-spinner"></i></b-button>
                </b-col>
             </b-row>
         </div>
       </b-card>
       <b-modal size="xs" v-model="modalimpresion">
            <template slot="modal-header">
                <div class="text-center">
                Telemovil.global
                </div>
            </template>
            <template>
            <plantilla :impresion="dataImpresion" :printweb="printweb"></plantilla>
            </template>
            <template slot="modal-footer">   
            <b-button size="sm"  class="btn btn-info" @click="print()"><i class="fas fa-print"></i> Imprimir</b-button>
            <b-button size="sm" class="btn btn-success" @click="nuevaImpresion()"><i class="fas fa-plus"></i> Nuevo</b-button>
            </template>
        </b-modal>
       <vue-snotify></vue-snotify>
    </div>
</template>
<script>
import axios from 'axios'
import { DocumentosIdentidad } from '@/shared/utils'
import { TipoMoneda } from '@/shared/utils'
// import { FormaPagoPDV } from '@/shared/utils'
import { FormaPagoCuentasCobrar } from '@/shared/utils'
import Plantilla from '@/components/comunes/PlantillaImpresion'
export default {
    name:'CasaCambio',
    components:{
        Plantilla
    },
    data() {
        return {
            selected: 2,
            options: [
                { value: 1, text: '(F) Factura' },
                { value: 2, text: '(B) Boleta' },           
            ],
            documentosIdentidad: DocumentosIdentidad,
            tipoDocumento: 0,
            tdocdisabled: false,
            receptor: {
                tipo: '',
                nro: '',
                razonSocial: '',
                direccionFiscal: ''
            },
            cargandoreceptor:false,
            listaReceptores: [],
            listarec:true,
            tipoMoneda: TipoMoneda,
            tipoMonedaPago: TipoMoneda,
            moneda: {
                id: '1',
                codigo: 'PEN',
                descripcion: 'SOLES',
                simbolo: 'S/.'
            },
            monedaPago: {
                id: '1',
                codigo: 'PEN',
                descripcion: 'SOLES',
                simbolo: 'S/.'
            },
            indexSerie: 0,
            listaSeries: [],
            seriesCargadas: false,
            items:[],
            items_fields:[
                {key:'descripcion', label:'Nombre'},
                {key:'cantidad', label:'Cantidad'},
                {key:'precioVentaUnitario', label:'Tipo Cambio'},
                {key:'accion',label:''}
            ],
            cargandomoneda: false,
            listaMoneda:false,
            productosMoneda:[],
            cadenabusqueda:'',
            //vista previa
            telefono: '',
            nombreComercial: '',
            direccion: '',
            paginaWeb: '',
            correo: '',
            textoPersonalizado1: '',
            textoPersonalizado2: '',
            checked: true,
            alto: '',
            urlimagen: '',
            documento:'',
            //tabla totales
            itemsAgregados:[],
            items_Agregados:[
                {key:'descripcion',label:'Nombre'},
                {key:'cantidad',label:'Cantidad'},
                {key:'precioVentaUnitario',label:'Tipo Cambio'},
                {key:'total',label:'Total'},
                {key:'borrar',label:''}
            ],
            sumaTotalesRecibe:0.00,
            sumaTotalesPagar:0.00,
            pagocon:'',
            listaPagos:[],
            vuelto:0.00,
            tipoCam:'',
            tipoCamNom:'',
            simboloT: false,
            documents:{
                monedero:"",
                nombreMonedero:"",
                serie: "",
                montoTotalImpuestos:0.0,
                totalVentaGravada:0.0,
                sumatoriaIgv:0.0,
                importeTotal:0.0,
                totalVentaInafecta:0.0,
                totalValorVenta:0.0,
                totalPrecioVenta:0.0,
                items:[],
                receptor: {
                tipo: '',
                nro: '',
                razonSocial: '',
                direccionFiscal: ''
                },
                adicional:{
                    dirAlternativa: "",
                    username:''
                }
            },
            formaPago: FormaPagoCuentasCobrar,
            formadepago: {
                codigo: '008',
                nombre: 'Efectivo ventas menores'
            },
            fpago: '',
            dataImpresion: {},
            pago:0.00,
            modalimpresion: false,
            vistaimpresion: false,
            newimpresion: true,
            action: {
                i: false,
                reset: false
            },
            printweb: false,
            pactual: 1,
            limite: 15,
            orden: "desc",
            total: 0.0,
            desde: 0.0,
            hasta: 0.0,
            cargando: false,
            filtroItems:[],
            casacambio:'1',
            mostrardni:false,
            norecdni:false,
            listadni:[],
            colorPago1:false,
            colorPago2:false,
            colorPago3:false,
            colorPago4:false,
            colorPago5:false,
            colorPago6:false,
            colorPago7:false,
            colorPago8:false,
            monederoPago:'',
        }
    },
    mounted(){
        this.getSeries();
        this.getDataImpresion();
        this.listProduct();
    },
    watch:{
       selected: function () {
           this.getSeries();
            if(this.selected==1){
                this.tipoDocumento = '6'
                this.tdocdisabled = true
            }else if(this.selected==2){
                this.tipoDocumento = '0'
                this.tdocdisabled = false
            }
        },
        modalimpresion: function () {
            if(this.modalimpresion == false){
                this.printweb = false
            }
        },
    },
    methods:{
        print: function () {
            this.printweb = true
        },
        getReceivers(){
            this.cargandoreceptor = true;
            this.listarec = true;
            axios
            .post(process.env.VUE_APP_API_URL + 'receptores/listaconterceros',{
                token: this.$store.getters.userToken,
                q: this.receptor.numero,
                tipoRec: this.tipoDocumento
            })
            .then(response =>(
                 this.listaReceptores = response.data,
                 this.cargandoreceptor = false,
                 this.receivercount(this.listaReceptores.length)
            ))
            .catch(error=>(
                this.listaReceptores = [],
                this.cargandoreceptor = false,
                this.listarec = false
            ))
        },
        receivercount: function (value){
                if(!value)
                {
                this.searchDNI();
                }
            },
            searchDNI(){
                this.cargandoreceptor = true
                this.mostrardni = true
                this.norecdni = false
                axios
                .get(process.env.VUE_APP_API_URL +'v2/dni',{
                    params:{
                        token: this.$store.getters.userToken,
                        dni: this.receptor.numero
                    }
                })
                .then(response => (
                        this.listadni = response.data,
                        this.cargandoreceptor = false,
                        this.receivedni(this.listadni)
                ))
                .catch(error => (
                    this.cargandoreceptor = false
                ))    
                
            },
            receivedni: function (value){
                if(!value)
                {
                    this.mostrardni = false
                    this.norecdni = true
                }
                else
                {
                    this.mostrardni = true
                    this.norecdni = false
                }
            },
            setReceiverdni(item){
                this.receptor.razonSocial = item.nombre
                this.mostrardni = false
                this.listarec = false
                this.listaReceptores = []
            },    
        getReceiversByRSocial: function () {
            this.cargandoreceptor = true;
            this.listarec = true;
            axios
            .post(process.env.VUE_APP_API_URL + 'receptores/lista/razonsocial',{
                token: this.$store.getters.userToken,
                q: this.receptor.razonSocial,
            })
            .then(response => (
                this.listaReceptores = response.data.response,
                this.cargandoreceptor = false
            ))
            .catch(function (error){
                this.cargandoreceptor = false,
                this.listarec = false
            })
        },
        pitcherReceiver: function () {
            if(this.receptor.razonSocial.length >= 3 ){
                    setTimeout(() => this.getReceiversByRSocial(), 200);
            }else if(this.receptor.razonSocial.length <= 2){
                    // this.initReceptor()
            }  
        },
        setReceiver: function (item) {
            this.receptor.numero = item.idReceptor,
            this.receptor.tipo = item.tipo,
            this.receptor.razonSocial = item.razonSocial,
            this.receptor.direccion = item.direccionReferencia,
            this.listarec = false
            if(item.tipo =="1"){
                this.tipoDocumento = 1
            }else if(item.tipo =="6"){
                this.tipoDocumento = 6
            }
            this.listaReceptores = []
        },
        getSeries: function () {
            this.seriesCargadas = true,
            axios
            .post(process.env.VUE_APP_API_URL + 'usuario/series/'+ this.selected, {
                token: this.$store.getters.userToken
            })
            .then(response => (
                this.listaSeries = response.data.data,
                this.seriesCargadas = false
            ))
            .catch(error => {
                this.seriesCargadas = false
            })
        },
        searchProduct: function() {
         this.cargandoproducto = true;
         this.listaMoneda = true;
            axios
            .post(process.env.VUE_APP_API_URL + "productos/buscar", {
                token: this.$store.getters.userToken,
                filtro: 'code',
                p: this.cadenabusqueda
            })
            .then(response => (
                this.productosMoneda = response.data.response,
                this.cargandoproducto = false
            ))
            .catch(error => (
                this.cargandoproducto = false,
                this.listaMoneda = false,
                this.$snotify.error(error.response.data.response.message, "Error")
            ));
        },
        setReceiverMoneda(item){
            let cambioMoneda = {}
            cambioMoneda.descripcion = item.descripcion,
            cambioMoneda.precioVentaUnitario = item.precioUnitario,
            cambioMoneda.codigo = item.codigo,
            cambioMoneda.cantidad = 0,

            cambioMoneda.valorVentaSinAfectar = item.precioUnitario,
            cambioMoneda.tipoAfectacionIgv = 30,
            cambioMoneda.codigoTributo = "9998",
            cambioMoneda.idProducto = item.idProducto,
            cambioMoneda.unidadMedidaCantidad = "NIU",
            cambioMoneda.valorUnitario = item.precioUnitario,
            cambioMoneda.tipoPrecioVentaUnitario = "01",
            cambioMoneda.baseAfectacionIgv = item.precioUnitario,
            cambioMoneda.valorVenta = item.precioUnitario,
            cambioMoneda.montoTotalImpuestosItem = 0,
            cambioMoneda.montoAfectacionIgv = 0,
            cambioMoneda.precioVentaUnitario = item.precioUnitario,
            cambioMoneda.porcentajeImpuesto = 0,      

            this.items.push(cambioMoneda)
            this.listaMoneda = false;
            this.cadenabusqueda = '';
            
        },
        getDataImpresion: function () {
            axios
            .post(process.env.VUE_APP_API_URL + 'movil/informacioncliente/mostrar', {
                token: this.$store.getters.userToken
            })
            .then(response => (
                this.dataLogo(response.data.response)
            ))
            .catch(error => (
                this.checked = true,
                this.alto = '100'
            ))
        },
        dataLogo: function (data) {
            this.urlimagen = this.$store.getters.userData.cuenta.uriImagen
            this.telefono = data.telefono
            this.nombreComercial = data.nombreComercial
            this.direccion =  data.direccion
            this.paginaWeb = data.paginaWeb
            this.correo = data.correo
            this.textoPersonalizado1 = data.textoPersonalizado1
            this.textoPersonalizado2 = data.textoPersonalizado2
             if(data.impLogo == 1){
                this.checked = true
                this.alto = data.altoLogo
                // this.ancho = data.anchoLogo
            }else if(data.impLogo == 0){
                this.checked = false
                this.alto = '100'
                // this.ancho = '150'
             }
        },
        agregarCambioMoneda(item,index){
            let agregados = {
                adicional:{
                    formaPago : ''
                }
            }
            agregados.unidadMedidaCantidad = "NIU",
            agregados.cantidad = item.cantidad;
            agregados.descripcion = item.descripcion;
            agregados.valorUnitario = item.precioUnitario,
            agregados.precioVentaUnitario = parseFloat(item.precioUnitario);
            agregados.tipoPrecioVentaUnitario = "01",
            agregados.montoTotalImpuestosItem = 0,
            agregados.baseAfectacionIgv = (item.precioUnitario) * (item.cantidad),
            agregados.montoAfectacionIgv = 0,
            agregados.porcentajeImpuesto = 0,
            agregados.tipoAfectacionIgv = 30,
            agregados.codigoTributo = "9998",
            agregados.valorVenta = (item.precioUnitario) * (item.cantidad)  
            agregados.codigo = item.codigo;  
            agregados.idProducto = item.idProducto,  
            agregados.codigoProductoSunat = "",
            agregados.adicional.formaPago = "",
            
            this.itemsAgregados.push(agregados);
            // this.items.splice(index,1);*
            this.sumarTotales();
        },
        sumarTotales(){
            let totalPagar = 0.00;
            this.itemsAgregados.forEach(function(element){
                  totalPagar +=  (element.cantidad) * (element.precioVentaUnitario)
            })
            this.sumaTotalesPagar = parseFloat(totalPagar.toFixed(2))
           return totalPagar.toFixed(2)
        },
        pagos(){
            if(this.fpago != '' && this.formadepago.codigo != '000'){
                let acumularpagos = {}
                acumularpagos.monto = this.fpago;
                acumularpagos.descripcion = this.formadepago.nombre 
                this.listaPagos.push(acumularpagos);
                this.fpago = '';
                this.pagoFinal();
            } 
        },
        pagoFinal(){
            let total = 0.00
            this.listaPagos.forEach(function(element){
                total += parseFloat(element.monto)
            })
            this.pago = total,
            total >= this.sumaTotalesPagar && this.sumaTotalesPagar > 0 ? this.vuelto = total - this.sumaTotalesPagar : this.vuelto = 0.00; 
            return total;
        },
        borrarCambio(index){
            this.itemsAgregados.splice(index,1);
            this.sumarTotales();

        },
        borrarItems(index){
            this.items.splice(index,1);
            if(this.items >= 0){
                this.tipoCamNom = '';
                this.tipoCam = ''; 
            } 
        },
        removePago: function (index) {
            this.listaPagos.splice(index,1)
        },
        emitirDocumento(){
            this.cargando = true;
            this.documents.token = this.$store.getters.userToken;
            if(this.selected == 1){
                this.documents.receptor.nro = this.receptor.numero.toString()
                this.documents.receptor.tipo = '6'
                this.documents.receptor.razonSocial = this.receptor.razonSocial
                this.documents.receptor.direccionFiscal = this.receptor.direccion 
            }else if(this.tipoDocumento == 0){
                this.documents.receptor.nro = '-'
                this.documents.receptor.tipo = '0'
                this.documents.adicional.otroNombre = this.receptor.razonSocial
                this.documents.adicional.dirAlternativa = this.receptor.direccion      
            }else{
                this.documents.receptor.nro = this.receptor.numero.toString()
                this.documents.receptor.razonSocial = this.receptor.razonSocial
                this.documents.receptor.direccionFiscal = this.receptor.direccion 
                this.documents.receptor.tipo = this.tipoDocumento.toString()
            }
            if(this.indexSerie == 0){
                this.documents.serie = this.listaSeries[0]
            }else{
                this.documents.serie = this.listaSeries[this.indexSerie]
            }
            this.documents.adicional.nombreFormaPago = this.formadepago.nombre
            this.documents.adicional.formaPago = this.formadepago.codigo;
            if(this.monederoPago == 1){
            this.documents.monedero = 1
            this.documents.nombreMonedero = "Yape"
            }else if(this.monederoPago == 2){
            this.documents.monedero = 2
            this.documents.nombreMonedero = "Plin"
            }else if(this.monederoPago == 4){
            this.documents.monedero = 4
            this.documents.nombreMonedero = "Tarjeta de Débito"
            }else if(this.monederoPago == 5){
            this.documents.monedero = 5
            this.documents.nombreMonedero = "Efectivo ventas menores"
            }else if(this.monederoPago == 6){
            this.documents.monedero = 6
            this.documents.nombreMonedero = "Tarjeta de Crédito emitida en Perú"
            }else if(this.monederoPago == 7){
            this.documents.monedero = 7
            this.documents.nombreMonedero = "Depósito en cuenta"
            }
            this.documents.montoTotalImpuestos = 0;
            this.documents.totalVentaGravada = 0;
            this.documents.sumatoriaIgv = 0;
            this.documents.importeTotal = this.sumaTotalesPagar;
            this.documents.totalVentaInafecta = this.sumaTotalesPagar;
            this.documents.totalValorVenta = this.sumaTotalesPagar;
            this.documents.totalPrecioVenta = this.sumaTotalesPagar;
            this.documents.adicional.username = this.$store.getters.userData.username;
            this.documents.items = this.itemsAgregados;
            this.documents.tipoOperacion = "0101";
            this.documents.tipoMoneda = this.moneda.codigo
            let ruta = '';
            this.selected==1 ? ruta = 'facturas/emitir': ruta = 'boletas/emitir';
            axios
            .post(process.env.VUE_APP_API_URL + ruta, this.documents)
            .then(response=>(
                this.$snotify.success(response.data.msg, 'Exito'),
                this.dataImpresion = response.data.response,
                this.dataImpresion.pago = this.pago,
                this.dataImpresion.vuelto = this.vuelto,
                this.dataImpresion.razonSocial = this.receptor.razonSocial,
                this.dataImpresion.direccion = this.receptor.direccion,
                this.dataImpresion.tiporeceptor = this.receptor.tipo,
                this.dataImpresion.adicionales = this.adicionales,
                this.dataImpresion.pagos = this.listaPagos,
                this.dataImpresion.casacambio = this.casacambio,

                this.modalimpresion = true,
                this.vistaimpresion = true,
                this.newimpresion = false,
                this.action.reset = true,
                this.cargando = false,
                this.limpiar()
            ))
            .catch(error=>(
                this.$snotify.error(error.response.data.msg,'Error') 
            ))
        },
        validarImporte(){
            if(this.selected == 1){
                this.emitirDocumento()
            }else{
                if(this.sumaTotalesPagar >= 700 && this.tipoDocumento == '0'){
                    this.$swal({
                    title: 'Atención!!!',
                    text: 'El importe total supera los 700 Soles, debe ingresa número de documento.',
                    icon: 'warning',
                    buttons: true,
                    dangerMode: true
                    }).then((willDelete) => {
                            
                    })
                }else{
                    if(this.tipoDocumento != '0' && this.receptor.numero !='' && this.receptor.razonSocial !=''){
                        this.emitirDocumento()
                    }else if(this.sumaTotalesPagar < 700 && this.tipoDocumento == '0'){
                        this.emitirDocumento()
                    }else{
                        this.$snotify.warning('Debe completar los datos del Receptor','Cuidado')
                    }    
                }
            }
        },
        validarDatos(){
            let serie = '';
            let pago = false;
            let totalpagado = this.pagoFinal();
            totalpagado >= this.sumaTotalesPagar ? pago = true: pago = false;
            this.indexSerie==0 ? serie = this.listaSeries[0]: serie = this.listaSeries[this.indexSerie]
           switch(this.selected){
                case 1: 
                    if(this.receptor.numero != '' && this.receptor.razonSocial != '' && this.itemsAgregados.length > 0 && serie != '' && pago){
                        return false
                    }else{
                        return true
                        }
                    break;
                case 2:
                    if(this.itemsAgregados.length > 0 && serie != '' && pago ){
                        return false
                    }else{
                        return true
                    }
                    break;
            } 
        },
        closeList(){
            this.listarec = false;
        },
        nuevaImpresion: function () {
            this.modalimpresion = false,
            this.vistaimpresion = false,
            this.newimpresion = true,
            this.limpiar()
        },
        limpiar(){
            this.receptor.numero = ''
            this.receptor.direccion = ''
            this.receptor.razonSocial = ''
            this.receptor.tipo ='6'
            this.fvencimiento = ''
            // this.items = [],
            this.itemsAgregados = [],
            this.listaPagos = [],
            this.formadepago = {
                codigo: '008',
                nombre: 'Efectivo ventas menores'
            }
        },
        listProduct(){
            axios
            .post(process.env.VUE_APP_API_URL + "productos/listar",{
                token: this.$store.getters.userToken,
                mostrarItemEn:2,
                page: this.pactual,
                limit: this.limite,
                order: this.orden
            })
            .then(response=>(       
                this.filtroItems = response.data.producto.data,
                (this.total = response.data.producto.total),
                (this.desde = response.data.producto.from),
                (this.hasta = response.data.producto.to),
                this.filtro()
            ))
            .catch(error=>(
                this.$snotify.error(error.response.data.response.message, "Error"),
                this.cargando = false
            ))
        },
        filtro(){
            // let resultadoFiltro = this.filtroItems.filter(filtro => filtro.mostrarItemEn == 2 || filtro.mostrarItemEn == 0)
            this.items = this.filtroItems;
        },
        pagosImg(valor){
            this.monederoPago = valor;
            valor == 1 ? this.colorPago1 = true : this.colorPago1 = false;
            valor == 2 ? this.colorPago2 = true : this.colorPago2 = false;
            valor == 4 ? this.colorPago4 = true : this.colorPago4 = false;
            valor == 5 ? this.colorPago5 = true : this.colorPago5 = false;
            valor == 6 ? this.colorPago6 = true : this.colorPago6 = false;
            valor == 7 ? this.colorPago7 = true : this.colorPago7 = false;
            valor == 8 ? this.colorPago8 = true : this.colorPago8 = false;
            if(valor == 1){
            this.formadepago.codigo = this.formaPago[3].codigo;
            this.formadepago.nombre = this.formaPago[3].nombre;
            }else if(valor == 2){
            this.formadepago.codigo = this.formaPago[3].codigo;
            this.formadepago.nombre = this.formaPago[3].nombre;
            }else if(valor == 4){
            this.formadepago.codigo = this.formaPago[4].codigo;
            this.formadepago.nombre = this.formaPago[4].nombre;
            }else if(valor == 5){
            this.formadepago.codigo = this.formaPago[8].codigo;
            this.formadepago.nombre = this.formaPago[8].nombre;
            }else if(valor == 6){
            this.formadepago.codigo = this.formaPago[5].codigo;
            this.formadepago.nombre = this.formaPago[5].nombre;
            }else if(valor == 7){
            this.formadepago.codigo = this.formaPago[2].codigo;
            this.formadepago.nombre = this.formaPago[2].nombre;
            }else if(valor == 8){
            this.formadepago.codigo = this.formaPago[3].codigo;
            this.formadepago.nombre = this.formaPago[3].nombre;
            }
        },
        validaMoneda(cant){
            if(cant > 0){
                return false
            }else{
                return true
            }
        }
    }
}
</script>
<style scoped>
.searcher-field{
  z-index: 1000;
  position: absolute;
  max-height: 400px !important;
  overflow-y: scroll;
  width: 500px
}
.searcher-result{
  font-size: smaller;
  padding: 2px 0px 2px 0px;
  cursor: pointer;
}
.searcher-field2{
  z-index: 1000;
  position: absolute;
  max-height: 400px;
  overflow-y: scroll;
  width: 500px;
}
.searcher-result2:hover{
border: 1px solid black;
padding: 5px 0px 5px 10px;
background-color:lightblue;
cursor: pointer;
}
.caja1{
    /* background-color: blue; */
    width:50%;
    border-right: 4px solid #ccc;
    padding-right: 35px;
    float: left;
    position: relative;
}
.caja2{
    width:50%;
    padding-left: 35px;
    float: left;
    position: relative;
}
.bordesVista{
   border: 1px solid black; 
   border-radius: 20px;
   width: 50%;
   
}
.formasPagosImg{
width: 40%;
height: 40%;
border-radius: 25px;
cursor: pointer;
}
</style>